//import React, { useCallback, useEffect, useMemo, useState } from "react";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import AppCtrl from "../../../control/AppCtrl";
import switchFunc from "../../../redux/switchFunc/switchFuncAction";
import Config from "../../../utils/Config";
import EFunction from "../../../utils/FunctionPage";
import LANGUAGE_TYPE from "../../../utils/Language";
import ScreenOrientation from "../../../utils/Orientation";
import Utils from "../../../utils/Utils";
import Input from "../../_component/Input";
import styles from "./index.module.scss";

import useAlert from "../../../hook/useAlert";
import useCookie from "../../../hook/useCookie";

// import { useNavigate } from 'react-router-dom';

let refreshTimeout = 60;
let hRefreshTimeout = null;
let hLoginTimeout = null;
let mChkDebugMode = null;
function LoginPage() {
  const text = Config.text.loginPage;
  const { setFunc } = switchFunc();
  const { setCookie, getCookie, delCookie } = useCookie();
  const { showAlert } = useAlert();
  // // const navigate = useNavigate();

  //===========================================================================
  const [countdown, setCountdown] = useState(0);
  const countdownRef = useRef(null);

  const [userAccount, setUserAccount] = useState("");
  const [userPassword, setUserPassword] = useState("");
  // const [userAccount, setUserAccount] = useState(
  //   AppCtrl.cacheAccount() || ""   // 預設值：cache > ""
  // );
  // const [userPassword, setUserPassword] = useState(
  //   AppCtrl.cachePassword() || ""
  // );
  const [userAgreement, setAgreement] = useState(false);
  const [userRememberMe, setRememberMe] = useState(false);

  const [loginHover, setLoginHover] = useState(false);
  const [registerHover, setRegisterHover] = useState(false);

  const loginImageUrl = useMemo(
    () =>
      loginHover
        ? `./img/loginpage/LoginDown.png?${Math.random()}`
        : `./img/loginpage/Login.png?${Math.random()}`,
    [loginHover]
  );

  const registerImageUrl = useMemo(
    () =>
      registerHover
        ? `./img/loginpage/registerDown.png?${Math.random()}`
        : `./img/loginpage/register.png?${Math.random()}`,
    [registerHover]
  );

  useEffect(() => {
    componentDidMount();
    return componentWillUnmount;
  }, []);
  // 啟動 RobotMode 倒數
  useEffect(() => {
    if (AppCtrl.isRobotMode()) {
      startRobotCountdown();
    }
    return () => {
      if (countdownRef.current) clearInterval(countdownRef.current);
    };
  }, []);
  //===========================================================================

  let regImg = "";
  let regImgDown = "";
  let loginImg = "";
  let loginImgDown = "";

  function startRobotCountdown() {
    setCountdown(10);
    if (countdownRef.current) clearInterval(countdownRef.current);

    countdownRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownRef.current);
          tryAutoLogin(); // 倒數結束嘗試登入
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  }

  function tryAutoLogin() {
    let account = AppCtrl.cacheAccount();
    let password = AppCtrl.cachePassword();

    // 如果沒有 cache，就用 React state (也就是 input 真正的值)
    if (!account) account = userAccount;
    if (!password) password = userPassword;

    if (account && password) {
      // 有帳密就自動登入
      setAgreement(true);
      setUserAccount(account);
      setUserPassword(password);
      onLoginClick(account, password, true);
    } else {
      // 沒帳密 → 再等 10 秒
      startRobotCountdown();
    }
  }

  function CheckDebugMode() {
    ///禁用右键（防止右键查看源代码）
    window.oncontextmenu = function () {
      return false;
    };
    //禁止任何键盘敲击事件（防止F12和shift+ctrl+i调起开发者工具）
    window.onkeydown =
      window.onkeyup =
      window.onkeypress =
        function (event) {
          // 判断是否按下F12，F12键码为123
          if (
            event.keyCode == 123 ||
            (event.shiftKey && event.ctrlKey && event.keyCode === 73)
          ) {
            event.preventDefault(); // 阻止默认事件行为
            window.event.returnValue = false;
          }
        };
    /*
        if (window.outerHeight - window.innerHeight > 200 || window.outerWidth - window.innerWidth > 200) {
            //document.body.innerHTML =
            //    "檢測到非正常Debug請刷新網頁!";
            window.close(); 
            window.location = "about:blank"; 
        }
        */
    /*
        setInterval(() => {
            (function () {
                return false;
            }
                ["constructor"]("debugger")
                ["call"]());
        }, 50);
        
        try {
            CheckDebugMode();
        } catch (err) {}
        */
    /*
        var h = window.innerHeight,w=window.innerWidth; 
        window.onresize = function () { 
            if (h!= window.innerHeight||w!=window.innerWidth){ 
                window.close(); 
                window.location = "about:blank"; 
            } 
        }
        */
  }

  function PreLoad() {
    AppCtrl.setLanguage(Config.language);
    AppCtrl.setCasinoName(Config.casinoName);
    AppCtrl.setFullscreenInBonusView(Config.fullscreenInBonusView);
    AppCtrl.setShowSpy(Config.showBtnSpy);
    AppCtrl.setShowDesc(Config.showBtnDesc);
    AppCtrl.setShowTrialCoins(Config.trialCoins);
    AppCtrl.setShowJackpotDisplay(Config.jackpotDisplayInLobby);
    AppCtrl.setKeyboardEnable(Config.keyboard);
    AppCtrl.setCheckOrientationInLobby(
      Config.checkOrientationInLobby ? Config.checkOrientationInLobby : false
    );
    AppCtrl.setShowKeyInCnt(Config.showKeyInCnt);
    AppCtrl.setShowPlayerLevel(Config.showPlayerLevel);

    ///禁用右键（防止右键查看源代码）
    //if(AppCtrl.getDebugForbidden() === true && bMobileDevice === false)
    if (AppCtrl.getDebugForbidden() === true) {
      window.oncontextmenu = function () {
        return false;
      };
      //禁止任何键盘敲击事件（防止F12和shift+ctrl+i调起开发者工具）
      window.onkeydown =
        window.onkeyup =
        window.onkeypress =
          function (event) {
            // 判断是否按下F12，F12键码为123
            if (
              event.keyCode == 123 ||
              (event.shiftKey && event.ctrlKey && event.keyCode === 73)
            ) {
              event.preventDefault(); // 阻止默认事件行为
              window.event.returnValue = false;
            }
          };
    }

    if (Config.agreementCheck === true) {
      setAgreement(true);
    }

    const bMobileDevice = Utils.detectmob();

    if (!Config.hometitle) {
      const elem = document.querySelector("#title");
      if (elem) elem.parentNode.removeChild(elem);
    }
    if (!Config.hometitlelogo) {
      const elem = document.querySelector("#titlelogo");
      if (elem) elem.parentNode.removeChild(elem);
    } else {
      //webhomelogo
      if (Config.webhomelogo && !Config.logingFromMachine) {
        for (let i = 0; i < Config.webhomelogo.length; i++) {
          const webhomelogoimg = Config.webhomelogo[i].img || "";
          if (webhomelogoimg.length > 0) {
            const uiLogoImg = document.getElementById("titlelogo");
            uiLogoImg.src = webhomelogoimg + `?${Math.random()}`;
            uiLogoImg.style.display = "";
            uiLogoImg.style.position = "relative";
            uiLogoImg.style.left = "0px";
            uiLogoImg.style.top = "5px";
            uiLogoImg.style.width = "100%";
            //uiLogoImg.style.height = '100%';
          }
        }
      } else {
        const elem = document.querySelector("#titlelogo");
        if (elem) elem.parentNode.removeChild(elem);
      }
    }

    if (Config.registerLogin) {
      let register = "";
      const url = Config.registerLogin.url || "";
      //register += url;
      const Gm = Config.registerLogin.Gm || "WinLobby";
      AppCtrl.setRegisterGM(Gm);
      //register += Gm;
      //const Prefix = Config.registerLogin.Prefix || "W_";
      const Prefix = Config.registerLogin.Prefix;
      AppCtrl.setPrefix(Prefix);
      const Notice = Config.registerLogin.notice;
      AppCtrl.setRegisterNotice(Notice);
    } else {
      const elem = document.querySelector("#registerbtn");
      if (elem) elem.parentNode.removeChild(elem);
    }

    document.title = Config.casinoName;
  }

  function onRegister() {
    setFunc(EFunction.register);
    // navigate('/register');
  }

  function componentDidMount() {
    PreLoad();
    //countDownRefresh();
    let account = null;
    let password = null;
    const urlParams = window.location.href;
    const index = urlParams.indexOf("?");
    if (index > 0) {
      const entries = urlParams.substring(index + 1).split("&");
      for (const entry of entries) {
        const strParams = entry.split("=");
        if (strParams.length !== 2) continue;

        switch (strParams[0]) {
          case "account":
            account = strParams[1];
            break;
          case "password":
            password = strParams[1];
            break;
        }
      }
    }
    if (account && password) {
      setUserAccount(account);
      setUserPassword(password);
      setAgreement(true);
      onLoginClick(account, password, true);
    } else {
      const cacheAccount = AppCtrl.cacheAccount();
      const cachePassword = AppCtrl.cachePassword();
      if (cacheAccount && cachePassword) {
        account = cacheAccount;
        password = cachePassword;
        console.log("Have Cached");
      } else if (getCookie("name") && getCookie("password")) {
        account = getCookie("name");
        password = getCookie("password");
        console.log("Have Cookie");
      } else {
        account = "";
        password = "";
        console.log("Empty account & password");
      }
      setUserAccount(account);
      setUserPassword(password);
      setAgreement(getCookie("agreement"));
      setRememberMe(getCookie("remeberMe"));
    }
    // let body = document.querySelector('body');
    // body.style.backgroundImage = `url("img/loginpage/imgLoginBG.jpg?${Math.random()}")`;
  }

  function componentWillUnmount() {
    if (hRefreshTimeout) {
      clearTimeout(hRefreshTimeout);
      hRefreshTimeout = null;
    }
    if (mChkDebugMode) {
      clearInterval(mChkDebugMode);
      mChkDebugMode = null;
    }
  }

  function countDownRefresh() {
    const uiMsg = document.getElementById("msg");
    if (uiMsg) uiMsg.innerHTML = ` ${refreshTimeout} 秒後將重新載入網頁`;

    hRefreshTimeout = setTimeout(function () {
      if (hRefreshTimeout) {
        clearTimeout(hRefreshTimeout);
        if (refreshTimeout > 0) {
          refreshTimeout--;
          // trigger again
          countDownRefresh();
          // let body = document.querySelector('body');
          // body.style.backgroundImage = `url("img/loginpage/imgLoginBG.jpg?${Math.random()}")`;
        } else {
          console.log("countDownRefresh");
          window.location.reload();
        }
      }
    }, 1000);
  }

  function onShowUserAgreement() {
    const agreeUrl = `${document.location.origin}${document.location.pathname}agreement.html`;
    //const content = `<iframe src="${agreeUrl}" style="width:100%;border-width:0px;overflow-y:auto"></iframe>`;
    let content = "";
    if (Config.agreement) {
      content = Config.agreement.notice;
      showAlert({
        title: content,
        text: "請閱讀協議內容",
        icon: "warning",
        showConfirmButton: true,
      });
    } else {
      //content = `<iframe src="${agreeUrl}" style="width:100%;border-width:0px;overflow-y:auto"></iframe>`;
      content = `<iframe src="${agreeUrl}" 
                          style="width:100%; height:420px; border:none; overflow-y:auto;">
                  </iframe>`;
      showAlert({
        title: "請閱讀協議內容",
        html: content, // ✅ 改這裡！使用 html 而不是 text
        icon: "warning",
        showConfirmButton: true,
      });
    }
  }

  function loginMouseover() {
    const element = document.getElementById("loginImg");
    if (element) element.src = `${loginImgDown}?${Math.random()}`;
  }

  function loginMouseout() {
    const element = document.getElementById("loginImg");
    if (element) element.src = `${loginImg}?${Math.random()}`;
  }

  function onLoginResponse(objRes) {
    // clear timeout
    if (hLoginTimeout) {
      clearTimeout(hLoginTimeout);
      hLoginTimeout = null;
    }

    const status = objRes.status;
    const language = AppCtrl.getLanguage();
    if (status == "success") {
      if (Config.fullScreenLockMachine === true) {
        Utils.enterFullScreen();
      }

      const checkOrientationInLobby = AppCtrl.CheckOrientationInLobby();
      if (checkOrientationInLobby) {
        AppCtrl.SetOrientationInLobby(ScreenOrientation.LandscapePrimary);
        AppCtrl.LandscapePortraitSetInLobby(ScreenOrientation.LandscapePrimary);
      }

      AppCtrl.setCacheAccount(userAccount);
      AppCtrl.setCachePassword(userPassword);
      const { agent, token, appId, award } = objRes;
      if (token && token.length > 0) {
        let awardMsg = "";
        let arardTitle = "";
        switch (language) {
          case LANGUAGE_TYPE.zh_TW:
            //arardTitle = "登入成功";
            if (award && award.value > 0) {
              arardTitle = "登入成功";
              awardMsg = "獎勵贈分: " + award.value + "\r\n已經加入您帳號。";
            }

            break;
          case LANGUAGE_TYPE.en_US:
          default:
            //arardTitle = "Loging Success";
            if (award && award.value > 0) {
              arardTitle = "Loging Success";
              awardMsg = "Award: " + award.value + "\r\n send to your account";
            }

            break;
        }
        if (arardTitle !== "" && awardMsg !== "") {
          if (!AppCtrl.isRobotMode()) {
            showAlert({
              title: arardTitle,
              text: awardMsg,
              icon: "success",
              showConfirmButton: false,
              timer: 1350,
            });
          }
        }

        AppCtrl.getUserScores();
        if (Config.logginnotice) {
          const logginnotice = Config.logginnotice.notice || "";
          if (logginnotice != "") {
            if (!AppCtrl.isRobotMode()) {
              showAlert({ title: logginnotice });
            }
          }
        }
        const withAPIGame = Config?.withAPIGame ?? false;
        AppCtrl.SetNewLogin(true);
        AppCtrl.getUserInfo(function (obj) {
          AppCtrl.requestLobbies();
          if (withAPIGame) {
            AppCtrl.requestAtgGames();
            AppCtrl.requestRsgGames();
          }
          // check if user isn't verified, switch to settingsPage
          const mainSettings = AppCtrl.mainSettings();

          const userInfo = AppCtrl.userInfo();
          if (
            !userInfo.AvatarInfo ||
            Object.keys(userInfo.AvatarInfo).length == 0
          ) {
            // manage cookie
            if (userRememberMe) {
              setCookie("name", userAccount);
              setCookie("password", userPassword);
              setCookie("agreement", userAgreement);
              setCookie("remeberMe", true);
            } else {
              delCookie("name");
              delCookie("password");
              delCookie("agreement");
              delCookie("remeberMe");
            }
            // if user's phone not verified, route to settingsPage
            if (mainSettings.VerifyUserInfo && !userInfo.Verified) {
              setFunc(EFunction.verifyPhone);
              // navigate('/verify-phone');
              if (!AppCtrl.isRobotMode()) {
                switch (language) {
                  case LANGUAGE_TYPE.zh_TW:
                    showAlert({ title: "驗證帳號能享受更多遊戲權利。" });
                    break;
                  case LANGUAGE_TYPE.en_US:
                  default:
                    showAlert({
                      title: "Verify account to enjoy more benefit.",
                    });
                    break;
                }
              }
            } else {
              // show winLobby for user to choose winLobbyManager
              setFunc(EFunction.winLobby);
              // navigate('/lobby');
            }
          } else {
            // show winLobby for avatar to choose winLobbyManager
            setFunc(EFunction.winLobby);
            // navigate('/lobby');
          }
          AppCtrl.getBonusBroadcast();
          if (Config?.urlBGImage) {
            if (Utils.isGifByExtension(Config.urlBGImage)) {
              document.body.style.backgroundImage = `url('${Config.urlBGImage}')`;
              //document.body.style.backgroundSize = "auto 100%";
              document.body.style.backgroundSize = "contain";
              document.body.style.backgroundRepeat = "no-repeat";
              document.body.style.backgroundPosition = "center center";
            } else {
              document.body.style.backgroundImage = `url('${Config.urlBGImage}')`;
              document.body.style.backgroundSize = "100% 100%";
            }
          }
        });
      } else {
        countDownRefresh();
        showAlert({ title: "Invalid token", text: "無效的鏈結值" });
      }
    } else {
      const err = objRes.error;
      switch (err) {
        case "密碼與電話不可相同": {
          AppCtrl.setCacheAccount(userAccount);
          AppCtrl.setCachePassword(userPassword);
          setFunc(EFunction.changePassword);
          // navigate('/change-password');
          // assign parameters
          const uiAccountInput = document.getElementById("userAccountInput");
          if (uiAccountInput) uiAccountInput.value = userAccount;
          const uiOldPasswordInput = document.getElementById(
            "userOldPasswordInput"
          );
          if (uiOldPasswordInput) uiOldPasswordInput.value = userPassword;
          const uiUserPhoneInput = document.getElementById("userPhoneInput");
          if (uiUserPhoneInput) uiUserPhoneInput.value = userPassword;
          if (!AppCtrl.isRobotMode()) {
            switch (language) {
              case LANGUAGE_TYPE.zh_TW:
                showAlert({ title: "您的密碼與電話相同，請變更密碼。" });
                break;
              case LANGUAGE_TYPE.en_US:
              default:
                showAlert({ title: "PhoneNo. Can not be same as password" });
                break;
            }
          }
          break;
        }
        case "禁止多重登入": {
          let title = "";
          let text = "";
          switch (language) {
            case LANGUAGE_TYPE.zh_TW:
              title = "重複登入";
              text = `是否登出前一個連線中的裝置？`;
              break;
            case LANGUAGE_TYPE.en_US:
            default:
              title = "multi-login";
              text = `logout previous device?`;
              break;
          }

          const confirmCb = () => {
            AppCtrl.requestLoginToken(
              userAccount,
              userPassword,
              true,
              onLoginResponse
            );
          };
          if (!AppCtrl.isRobotMode()) {
            showAlert({
              title,
              text,
              icon: "warning",
              showCancelButton: true,
              confirmCb,
            });
          }
          break;
        }
        default: {
          showAlert({ title: err ? err : "unable to get login token" });
          break;
        }
      }
    }
  }

  const onAccountChanged = useCallback((e) => {
    setUserAccount(e.target.value);
  }, []);

  const onPasswordChanged = useCallback((e) => {
    setUserPassword(e.target.value);
  }, []);

  const onAgreement = useCallback(() => {
    setAgreement(!userAgreement);
  }, [userAgreement]);

  const onRemeberMe = useCallback(() => {
    setRememberMe(!userRememberMe);
  }, [userRememberMe]);

  function onLoginClick(accountParam, passwordParam, auto = false) {
    // 如果是事件物件，把它丟掉
    if (
      typeof accountParam === "object" &&
      accountParam !== null &&
      "bubbles" in accountParam
    ) {
      accountParam = null;
    }

    const account = accountParam || userAccount;
    const password = passwordParam || userPassword;
    const agreement = AppCtrl.isRobotMode() ? true : userAgreement; // 自動登入不檢查
    if (!account || !password) {
      showAlert({ title: "請填入帳號與密碼" });
    } else if (!agreement) {
      showAlert({
        title: "請同意協議",
        icon: "warning",
        confirmButtonText: "確定",
      });
    } else {
      setUserAccount(account);
      setUserPassword(password);
      // reset refresh timeout
      if (hRefreshTimeout) {
        clearTimeout(hRefreshTimeout);
        hRefreshTimeout = null;
        refreshTimeout = 60;
      }
      // show alert
      //const msg = `正在連線遊戲中\n請稍候。`;
      const language = AppCtrl.getLanguage();
      let msg = "";
      switch (language) {
        case LANGUAGE_TYPE.zh_TW:
          //msg = `正在連線遊戲中\n請稍候。`;
          break;
        case LANGUAGE_TYPE.en_US:
        default:
          //msg = `Connect to Game\n Please wait`;
          break;
      }
      //content, subcontent = '',iconType = 'error', showButton = true, buttonText = '關閉', showLoading = false, closetimer = 2000
      //   AppCtrl.popup(msg, "", "", false, "", 0);
      if (msg !== "") {
        if (!AppCtrl.isRobotMode()) {
          showAlert({
            title: msg,
            showConfirmButton: false,
          });
        }
      }

      if (hLoginTimeout) clearTimeout(hLoginTimeout);
      hLoginTimeout = setTimeout(function () {
        switch (language) {
          case LANGUAGE_TYPE.en_US:
            showAlert({
              title: "Connect to Game failed",
              text: "Timeout",
            });
            break;
          case LANGUAGE_TYPE.zh_TW:
            showAlert({ title: "連線失敗", text: "逾期" });
            break;
        }
        hLoginTimeout = null;
      }, 15000);
      // maybe build network connection here and then request token
      AppCtrl.connectToServer(null, function () {
        AppCtrl.requestConfig();
        //send request token
        AppCtrl.requestLoginToken(account, password, false, onLoginResponse);
      });
    }
  }
  //<h2 class="logo" id="title">線上實境娛樂</h2> //Gold
  //<h2 class="slider-menu" style={{fontSize:"36px"}} id="title">線上實境娛樂</h2>
  //<h2 class="slider-menu" style={{fontSize:"36px"}} id="title">{`${Config.casinoName}`}</h2>
  //<h2 class="logo" id="title">{`${Config.casinoName}`}</h2>
  return (
    <div id="loginPage" className={styles.loginPage}>
      {AppCtrl.isRobotMode() && countdown > 0 && (
        <div
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            backgroundColor: "rgba(0,0,0,0.6)",
            color: "#fff",
            padding: "5px 10px",
            borderRadius: "5px",
            fontSize: "16px",
            fontWeight: "bold",
            zIndex: 9999, // ✅ 確保顯示在最上層
          }}
        >
          自動登入倒數 {countdown} 秒
        </div>
      )}
      <div className={styles.container}>
        <div className={styles.header}>
          {Config.homeslogan && text.slogan ? (
            <p class="aeu-signature" id="slogan">{`${text.slogan}`}</p>
          ) : null}
          {Config.homeheaderbar ? (
            <div class="header-bar">
              <h2
                class="slider-menu"
                style={{ fontSize: "36px" }}
                id="title"
              >{`${Config.casinoName}`}</h2>
            </div>
          ) : null}
          <img id="titlelogo" src=""></img>
          {Config.homeslogan1 && text.slogan_1 ? (
            <p class="ttp">{`${text.slogan_1}`}</p>
          ) : null}
          <div id="msg" style={{ fontSize: "12px" }}></div>
        </div>
        {!Config.logingFromMachine && (
          <div className={styles.form}>
            <div>
              <Input
                type="text"
                className={styles.input}
                placeholder={`${text.account_placeholder}`}
                value={userAccount}
                onChange={onAccountChanged}
              />
            </div>
            <div>
              <Input
                type="password"
                className={styles.input}
                placeholder={`${text.password_placeholder}`}
                value={userPassword}
                onChange={onPasswordChanged}
              />
            </div>
            <div>
              <Input
                type="checkbox"
                className={styles.checkbox}
                onClick={onAgreement}
                checked={userAgreement}
              />
              <span className={styles.checkBox_text}>
                <span className={styles.purpleText}>{`${text.agreement}`}</span>
                <a
                  href="#"
                  style={{
                    color: "#ffffff", // 文字填充白色
                    fontWeight: "bold", // 粗體
                    fontSize: "26px",
                    //WebkitTextStroke: "1px red"   // 文字描邊 1px 紅色
                  }}
                  onClick={onShowUserAgreement}
                >{`${text.agreementcontent}`}</a>
              </span>
            </div>
            <div>
              <Input
                type="checkbox"
                className={styles.checkbox}
                onClick={onRemeberMe}
                checked={userRememberMe}
              />
              <span className={styles.checkBox_text}>
                <span className={styles.purpleText}>
                  {`${text.remeberMe_1}`}
                </span>
              </span>
            </div>
          </div>
        )}
        {!Config.logingFromMachine && (
          <div className={styles.bottom}>
            {/* <div id="login" onClick={() => onLoginClick(userAccount, userPassword, userAgreement)}></div>  */}
            {/* <div id="registerLogin"> </div> */}
            {/* <div id="socialmedia"> </div> */}
            <img
              src={loginImageUrl}
              onMouseEnter={() => setLoginHover(true)}
              onMouseLeave={() => setLoginHover(false)}
              className={styles.image}
              onClick={onLoginClick}
            />
            <img
              id="registerbtn"
              src={registerImageUrl}
              onMouseEnter={() => setRegisterHover(true)}
              onMouseLeave={() => setRegisterHover(false)}
              className={styles.image}
              onClick={onRegister}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                overflowX: "auto", // 開啟水平滾動
                whiteSpace: "nowrap", // 保持子元素在一行
              }}
            >
              {Config.webLinkhome && Config.webLinkhome.length > 0
                ? Config.webLinkhome.map((item, index) => {
                    return (
                      <a
                        href={item.url}
                        target="_blank"
                        key={`${item.url}_${index}`}
                      >
                        <img
                          src={item.img}
                          className={styles.socialMedia}
                          key={index}
                        />
                      </a>
                    );
                  })
                : null}
            </div>
          </div>
        )}
        <div style={{ fontSize: "14px", textAlign: "right", width: "100%" }}>
          {/* 將 code: 和版本號 span 包在新 span 裡 */}
          <span className={styles.versionText}>
            code:{" "}
            <span>{`${Config.VerCode ? Config.VerCode : "0.0.0.0"}`}</span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
